import { AnyAction } from 'redux'

export { default as actions } from './actions'

export enum SuggestionReasonTypes {
  REQUEST_SUGGESTION_REASONS = 'REQUEST_SUGGESTION_REASONS',
  UPDATE_SUGGESTION_REASONS = 'UPDATE_SUGGESTION_REASONS',
  FAIL_SUGGESTION_REASONS = 'FAIL_SUGGESTION_REASONS',
  NONE = '',
}

export interface SuggestionReason {
  value: string
  label: string
}

export interface SuggestionReasonState {
  reasons: SuggestionReason[]
  maxLength: number
  requested: boolean
}

export const DEFAULT_NOTE_MAX_LENGTH = 5000

const INITIAL_STATE: SuggestionReasonState = {
  reasons: [],
  maxLength: DEFAULT_NOTE_MAX_LENGTH,
  requested: false,
}

const suggestionReasons = (
  state = INITIAL_STATE,
  action: AnyAction = {
    type: SuggestionReasonTypes.NONE,
    payload: [],
  },
) => {
  switch (action.type) {
    case SuggestionReasonTypes.REQUEST_SUGGESTION_REASONS:
      return {
        ...state,
        requested: true,
      }
    case SuggestionReasonTypes.FAIL_SUGGESTION_REASONS:
      return {
        ...state,
        requested: false,
      }
    case SuggestionReasonTypes.UPDATE_SUGGESTION_REASONS:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}

export default suggestionReasons
